import { PageTitle, useLayout } from '../../../_metronic/layout/core';
import { DefaultTitle } from '../../../_metronic/layout/components/header/page-title/DefaultTitle';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { IRazaoLayoutConfig } from '../../interfaces/IRazaoLayoutConfig';
import razaoLayoutConfigService from '../../services/razaoLayoutConfigService';

const colLabel = (n?: number) => {
  if (!n) return '—';
  const letter = String.fromCharCode(64 + n);
  return `${letter} (${n})`;
};

function RazaoLayouts() {
  const history = useHistory();
  const { classes } = useLayout();
  const [dados, setDados] = useState<IRazaoLayoutConfig[]>([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const result = await razaoLayoutConfigService.getAll();
    setDados(result);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleDelete = async (item: IRazaoLayoutConfig) => {
    const confirm = await Swal.fire({
      title: `Excluir layout "${item.tipoRazao}"?`,
      text: 'Esta ação não pode ser desfeita.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33',
    });

    if (!confirm.isConfirmed) return;

    const ok = await razaoLayoutConfigService.delete(item.id);
    if (ok) {
      Swal.fire({ text: 'Layout excluído.', timer: 2500, icon: 'success', showConfirmButton: false });
      load();
    }
  };

  return (
    <>
      <PageTitle breadcrumbs={[]}>Layouts de Razão Contábil</PageTitle>
      <div className='toolbar' id='kt_toolbar'>
        <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
          <DefaultTitle />
        </div>
      </div>

      <div className='card'>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            <span className='text-muted fs-7'>
              Configure os mapeamentos de colunas para cada tipo de arquivo de Razão Contábil.
            </span>
          </div>
          <div className='card-toolbar'>
            <button
              className='btn btn-primary'
              onClick={() => history.push('/parametrizacoes/razao/layouts/novo')}
            >
              + Novo Layout
            </button>
          </div>
        </div>

        <div className='card-body py-4'>
          {loading ? (
            <div className='d-flex justify-content-center align-items-center py-10'>
              <div className='spinner-border text-primary' role='status'>
                <span className='visually-hidden'>Carregando...</span>
              </div>
            </div>
          ) : (
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-4 gy-4'>
                <thead>
                  <tr className='fw-bold text-muted bg-light'>
                    <th className='min-w-140px ps-4 rounded-start'>Tipo</th>
                    <th className='min-w-200px'>Descrição</th>
                    <th className='min-w-100px text-center'>Empresa col.</th>
                    <th className='min-w-100px text-center'>CNPJ col.</th>
                    <th className='min-w-100px text-center'>Conta col.</th>
                    <th className='min-w-80px text-center'>Ativo</th>
                    <th className='min-w-100px text-end pe-4 rounded-end'>Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {dados.length === 0 ? (
                    <tr>
                      <td colSpan={7} className='text-center text-muted py-8 fs-6'>
                        Nenhum layout cadastrado. Clique em "+ Novo Layout" para começar.
                      </td>
                    </tr>
                  ) : (
                    dados.map(item => (
                      <tr key={item.id}>
                        <td className='ps-4'>
                          <span className='badge badge-light-primary fs-7'>{item.tipoRazao}</span>
                        </td>
                        <td>
                          <span className='text-dark fw-semibold d-block fs-6'>{item.descricao}</span>
                        </td>
                        <td className='text-center'>
                          <span className='text-muted fs-7'>{colLabel(item.empresaValorColuna)}</span>
                        </td>
                        <td className='text-center'>
                          <span className='text-muted fs-7'>{colLabel(item.cnpjValorColuna)}</span>
                        </td>
                        <td className='text-center'>
                          <span className='text-muted fs-7'>
                            cód. {colLabel(item.contaCodigoColuna)} / nome {colLabel(item.contaNomeColuna)}
                          </span>
                        </td>
                        <td className='text-center'>
                          <span className={`badge badge-light-${item.ativo ? 'success' : 'danger'} fs-7`}>
                            {item.ativo ? 'Sim' : 'Não'}
                          </span>
                        </td>
                        <td className='text-end pe-4'>
                          <button
                            className='btn btn-sm btn-light-primary me-2'
                            onClick={() => history.push(`/parametrizacoes/razao/layouts/${item.id}`)}
                          >
                            Editar
                          </button>
                          <button
                            className='btn btn-sm btn-light-danger'
                            onClick={() => handleDelete(item)}
                          >
                            Excluir
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default RazaoLayouts;
